import { createContext, useContext } from "react";

interface IWizardContext {
  activeStep?: number;
  setActiveStep?: (integer) => void;
  goNext?: () => void;
  goPrevious?: () => void;
  close?: () => void;
  setChangingStepInProgress?: (boolean) => void;
}

const WizardContext = createContext<IWizardContext>({});

export const WizardContextProvider = WizardContext.Provider;
export const WizardContextConsumer = WizardContext.Consumer;

export const useWizardContext = (): IWizardContext => useContext(WizardContext);

export default WizardContext;
